import environment from 'environment';
import { getRequest, postRequest } from '..';

const { SIMPLR_ORDER_BASE_URL } = environment.eCommerce;

export const simplrOrderGetQuery = getRequest(SIMPLR_ORDER_BASE_URL);
export const simplrOrderPostQuery = postRequest(SIMPLR_ORDER_BASE_URL);
